import styled from "styled-components";

export const PageLocationTitle = styled.h1`
  color: rgb(25, 31, 40);
  text-transform: uppercase;
  font-size: 24px;
  width: 100%;
  font-weight: 600;
  font-family: "Barlow Condensed", sans-serif;
  letter-spacing: 0.5px;
`;

export const SummaryCard = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 2px 8px rgba(26, 34, 82, 0.08);
  border: 1px solid rgba(26, 34, 82, 0.06);
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0px 4px 16px rgba(26, 34, 82, 0.12);
  }
`;

export const SummaryValue = styled.span`
  font-size: 32px;
  font-weight: 700;
  color: #1a2252;
  font-family: "Barlow Condensed", sans-serif;
`;

export const SummaryLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #6b7490;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-top: 4px;
`;
